import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { ClientSdkPublicInterface } from "../../sdk/ClientSdkPublicInterface.js";
import { ChainableEvaluation, NamedChainableEvaluation } from "./ChainedCTAEvaluator.js";
import { EvaluatedAction } from "../EvaluatedAction.js";
import { EvaluationName } from "./EvaluatedActionExecutor.js";


export interface EvaluationThrottler {
    throttled(inputEval: ChainableEvaluation): ChainableEvaluation
    throttleNamed(name: EvaluationName, inputEval: ChainableEvaluation): NamedChainableEvaluation
}


export interface ThrottleClause {
    
    checkIfShouldExecute(): Promise<boolean>;
    setExecuted(): Promise<void>;
    clearThrottle(): Promise<void>;
}


export class EvaluationThrottlerImpl implements EvaluationThrottler {
    

    constructor(
        private readonly clause: ThrottleClause,
        private readonly throttledValue: EvaluatedAction<any>
    ) {

    }

    public throttled(inputEval: ChainableEvaluation): ChainableEvaluation {
        return ((s: ClientSdkPublicInterface, logger: Logger) => {
            return this.clause.checkIfShouldExecute().then(shouldExec => {
                if(shouldExec) {
                    return inputEval(s, logger).then(res => {
                        if (res) {
                            res.onExecutionMark = () => this.clause.setExecuted();
                        }
                        return res;
                    });                   
                }
                else return Promise.resolve(this.throttledValue);
            });
            
        });
    }

    public throttleNamed(name: EvaluationName, inputEval: ChainableEvaluation): NamedChainableEvaluation {
        const throttledEval = this.throttled(inputEval);
        return {
            name: name,
            evaluation: throttledEval,
            beforeForcedExecution: () => this.clause.clearThrottle()
        };
    }

}

export function throttleEvaluation(clause: ThrottleClause, defVal: EvaluatedAction<any>,
    evaluation: ChainableEvaluation): ChainableEvaluation {

    const throttler = new EvaluationThrottlerImpl(clause, defVal);
    return throttler.throttled(evaluation);
}


export function throttleNamedEvaluation(name: EvaluationName, clause: ThrottleClause, defVal: EvaluatedAction<any>,
    evaluation: ChainableEvaluation): NamedChainableEvaluation {
       
        
    const throttler = new EvaluationThrottlerImpl(clause, defVal);
    return throttler.throttleNamed(name,evaluation);
}